import { Component, OnInit, Output, EventEmitter, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";
import { ApplicationSummary, Organisation, ApplicationClaim } from "../../../models";
import { CurrentUserService } from "../../../services/shared";
import { ApplicationService } from "./applications.service";

@Component({
    selector: "applications-component",
    template: require("./applications.component.html"),
    styles: [require("./applications.component.less").toString()],
    providers: [ApplicationService]
})


export class ApplicationComponent implements OnDestroy, OnInit {
    @Output() reloadMyhome: EventEmitter<any> = new EventEmitter();
    subscriber: Subscription;
    errorMessage: string;
    activeTabId: number = 0;
    tabTitle: string;
    totalCount: string;
    isAdministrator: boolean;
    accountOrganisationId: string;
    applicationClaimListObservable: Observable<ApplicationClaim[]>;
    appInfo = new Array<ApplicationSummary>();
    appWarningInfo = new Array<ApplicationSummary>();
    appInfoOrganisations = new Array<Organisation>();
    constructor(private netIdRouter: Router, private applicationService: ApplicationService, private currentUserService: CurrentUserService) {
        this.subscriber = applicationService.updateConfirmed$.subscribe(
            totalItems => { this.totalCount = " (" + totalItems + ")"; });
    }
    public ngOnInit(): void {
        this.isAdministrator = this.currentUserService.IsOrgAdmin() || this.currentUserService.IsDiocesanAdmin();
        if (this.currentUserService.token && !this.currentUserService.userInfo) {
            this.accountOrganisationId = this.currentUserService.userInfo.organisation.accountOrganisationId;

        }
    }

    public setCurrentTab(tabIndex: number): void {
        if (tabIndex === 2) {
            this.applicationClaimListObservable = this.applicationService.GetApplicationClaims(this.appInfo[0].applicationId);
            this.accountOrganisationId = this.currentUserService.userInfo.organisation.accountOrganisationId;
        }
        this.activeTabId = tabIndex;
    };

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }
    public onRedirect(tabIndex: number): void {
        this.setCurrentTab(tabIndex);
    }

    public onRefreshAppInfo(applications: ApplicationSummary[]): void {
        this.appInfo = applications;
        this.isAdministrator = this.currentUserService.IsOrgAdmin() || this.currentUserService.IsDiocesanAdmin();
    }

    public onRefreshWarningInfo(applications: ApplicationSummary[]): void {
        this.appWarningInfo = applications;
    }

    public onRefreshClaims(applications: ApplicationSummary[]): void {
        this.appWarningInfo = applications;
    }

    public onRefreshAppInfoOrganisations(organisations: Organisation[]): void {
        this.appInfoOrganisations = organisations;
    }

    public onReloadMyhome(): void {
        this.reloadMyhome.emit();
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/applications/applications.component.ts